import { createSelector } from 'reselect';
import isEmpty from 'lodash/isEmpty';

const isFetchingState = state => state.adPage.isFetching;
const isSendingApplyState = state => state.adPage.isSendingApply;
const applyErrorState = state => state.adPage.applyError;
const adsContactedState = state => state.adPage.adsContacted;
const relatedAdsState = state => state.adPage.relatedAds;
const adState = state => state.adPage.ad;
const errorState = state => state.adPage.error;
const isRelatedAdsFetchEnabledState = state => state.adPage.isRelatedAdsFetchEnabled;

export const isFetchingSelector = createSelector(
  isFetchingState,
  isFetching => isFetching
);

export const isSendingApplySelector = createSelector(
  isSendingApplyState,
  isSendingApply => isSendingApply
);

export const applyErrorSelector = createSelector(
  applyErrorState,
  applyError => applyError
);

export const adsContactedSelector = createSelector(
  adsContactedState,
  adsContacted => adsContacted
);

export const adSelector = createSelector(
  adState,
  ad => (isEmpty(ad) ? null : ad)
);

export const errorSelector = createSelector(
  errorState,
  error => error
);

export const relatedAdsSelector = createSelector(
  relatedAdsState,
  relatedAds => relatedAds || null
);

export const isRelatedAdsFetchEnabledSelector = createSelector(
  isRelatedAdsFetchEnabledState,
  isRelatedAdsFetchEnabled => isRelatedAdsFetchEnabled
);



// WEBPACK FOOTER //
// ./app/AdPage/selectors.js